module.exports = __webpack_public_path__ + "img/SKB.703ca193.svg";